"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.coronaryDiseaseTypeMessages = exports.cardiovascularDiseaseTypeMessages = exports.hasDiseaseMessages = exports.CoronaryDiseaseType = exports.CardiovascularDiseaseType = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_CARDIOVASCULAR_DISEASE"] = "has_cardiovascular_disease";
    HasDisease["NO_UNKNOWN_CARDIOVASCULAR_DISEASE"] = "no_unknown_cardiovascular_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var CardiovascularDiseaseType;
(function (CardiovascularDiseaseType) {
    CardiovascularDiseaseType["PRIMARY_HYPERTENSION"] = "primary_hypertension";
    CardiovascularDiseaseType["SECONDARY_HYPERTENSION"] = "secondary_hypertension";
    CardiovascularDiseaseType["TIA_ISCHEMIC_STROKE"] = "TIA_ischemic_stroke";
    CardiovascularDiseaseType["HAEMORRHAGIC_STROKE"] = "haemorrhagic_stroke";
    CardiovascularDiseaseType["CORONARY_DISEASE"] = "coronary_disease";
    CardiovascularDiseaseType["HYPERTHROPHIC_CARDIOMYOPATHY"] = "hyperthrophic_cardiomyopathy";
    CardiovascularDiseaseType["DIALATATIVE_CARDIOMYOPATHY"] = "dialatative_cardiomyopathy";
    CardiovascularDiseaseType["ATRIAL_FIBRILLATION_OR_OTHER_ARRYTHMIA"] = "atrial_fibrillation_or_other_arrythmia";
    CardiovascularDiseaseType["AORTIC_STENOSIS_OR_INSUFFICIENCY"] = "aortic_stenosis_or_insufficiency";
    CardiovascularDiseaseType["MITRAL_STENOSIS_OR_INSUFFICIENCY"] = "mitral_stenosis_or_insufficiency";
    CardiovascularDiseaseType["AORTA_ANEURYSM"] = "aorta_aneurysm";
    CardiovascularDiseaseType["ATHEROSCLEROSIS_ARTERIAE_CAROTIDEAE"] = "atherosclerosis_arteriae_carotideae";
    CardiovascularDiseaseType["STENOSIS_ARTERIAE_CONORARIAE"] = "stenosis_arteriae_conorariae";
    CardiovascularDiseaseType["STENOSIS_ARTERIAE_RENALIS"] = "stenosis_arteriae_renalis";
    CardiovascularDiseaseType["PERIPHERAL_ARTERY_DIESEASE"] = "peripheral_artery_diesease";
    CardiovascularDiseaseType["OTHER_CARDIOVASCULAR_DISEASE"] = "other_cardiovascular_disease";
})(CardiovascularDiseaseType || (exports.CardiovascularDiseaseType = CardiovascularDiseaseType = {}));
var CoronaryDiseaseType;
(function (CoronaryDiseaseType) {
    CoronaryDiseaseType["CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITH_INTERVENTION"] = "Coronary_artery_disease_obstructive_with_intervention";
    CoronaryDiseaseType["CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITHOUT_INTERVENTION"] = "Coronary_artery_disease_obstructive_without_intervention";
    CoronaryDiseaseType["CORONARY_ARTERY_DISEASE_NON_OBSTRUCTIVE"] = "Coronary_artery_disease_non_obstructive";
})(CoronaryDiseaseType || (exports.CoronaryDiseaseType = CoronaryDiseaseType = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_CARDIOVASCULAR_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.hasDisease.HAS_CARDIOVASCULAR_DISEASE",
        defaultMessage: "Diagnosztizált kardiovaszkuláris betegség"
    },
    [HasDisease.NO_UNKNOWN_CARDIOVASCULAR_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.hasDisease.NO_UNKNOWN_CARDIOVASCULAR_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.cardiovascularDiseaseTypeMessages = {
    [CardiovascularDiseaseType.PRIMARY_HYPERTENSION]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.PRIMARY_HYPERTENSION",
        defaultMessage: "Primer Hypertonia"
    },
    [CardiovascularDiseaseType.SECONDARY_HYPERTENSION]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.SECONDARY_HYPERTENSION",
        defaultMessage: "Secunder Hypertonia"
    },
    [CardiovascularDiseaseType.TIA_ISCHEMIC_STROKE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.TIA_ISCHEMIC_STROKE",
        defaultMessage: "TIA/iszkémiás stroke"
    },
    [CardiovascularDiseaseType.HAEMORRHAGIC_STROKE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.HAEMORRHAGIC_STROKE",
        defaultMessage: "Hemorrhágiás stroke"
    },
    [CardiovascularDiseaseType.CORONARY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.CORONARY_DISEASE",
        defaultMessage: "Koronáriabetegség"
    },
    [CardiovascularDiseaseType.HYPERTHROPHIC_CARDIOMYOPATHY]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.HYPERTHROPHIC_CARDIOMYOPATHY",
        defaultMessage: "Hyperthrophiás cardiomyopathia"
    },
    [CardiovascularDiseaseType.DIALATATIVE_CARDIOMYOPATHY]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.DIALATATIVE_CARDIOMYOPATHY",
        defaultMessage: "Dilatativ cardiomyopathia"
    },
    [CardiovascularDiseaseType.ATRIAL_FIBRILLATION_OR_OTHER_ARRYTHMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.ATRIAL_FIBRILLATION_OR_OTHER_ARRYTHMIA",
        defaultMessage: "Pitvarfibrilláció vagy egyéb ritmuszavar"
    },
    [CardiovascularDiseaseType.AORTIC_STENOSIS_OR_INSUFFICIENCY]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.AORTIC_STENOSIS_OR_INSUFFICIENCY",
        defaultMessage: "Aorta stenosis és vagy elégtelenség"
    },
    [CardiovascularDiseaseType.MITRAL_STENOSIS_OR_INSUFFICIENCY]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.MITRAL_STENOSIS_OR_INSUFFICIENCY",
        defaultMessage: "Mitrális billentyű stenosis és vagy elégtelenség"
    },
    [CardiovascularDiseaseType.AORTA_ANEURYSM]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.AORTA_ANEURYSM",
        defaultMessage: "Aorta aneurysma"
    },
    [CardiovascularDiseaseType.ATHEROSCLEROSIS_ARTERIAE_CAROTIDEAE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.ATHEROSCLEROSIS_ARTERIAE_CAROTIDEAE",
        defaultMessage: "Arteria carotis atherosclerosis"
    },
    [CardiovascularDiseaseType.STENOSIS_ARTERIAE_CONORARIAE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.STENOSIS_ARTERIAE_CONORARIAE",
        defaultMessage: "Arteria carotis stenosis"
    },
    [CardiovascularDiseaseType.STENOSIS_ARTERIAE_RENALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.STENOSIS_ARTERIAE_RENALIS",
        defaultMessage: "Arteria renalis szűkület"
    },
    [CardiovascularDiseaseType.PERIPHERAL_ARTERY_DIESEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.PERIPHERAL_ARTERY_DIESEASE",
        defaultMessage: "Perifériás verőérbetegség"
    },
    [CardiovascularDiseaseType.OTHER_CARDIOVASCULAR_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.cardiovascularDiseaseType.OTHER_CARDIOVASCULAR_DISEASE",
        defaultMessage: "Egyéb kardiovaszkuláris betegség"
    }
};
exports.coronaryDiseaseTypeMessages = {
    [CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITH_INTERVENTION]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.coronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITH_INTERVENTION",
        defaultMessage: "Koronária betegség - Obstruktív intervencióval"
    },
    [CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITHOUT_INTERVENTION]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.coronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITHOUT_INTERVENTION",
        defaultMessage: "Koronária betegség - Obstruktív intervenció nélkül"
    },
    [CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_NON_OBSTRUCTIVE]: {
        id: "ktx.transplantationScreening.medicalHistory.cardiovascularDiseases.coronaryDiseaseType.CORONARY_ARTERY_DISEASE_NON_OBSTRUCTIVE",
        defaultMessage: "Koronária betegség - Non-obstruktív"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_CARDIOVASCULAR_DISEASE).interpretation({ vocab: "ktx", code: "has_cardiovascular_disease" }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_CARDIOVASCULAR_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_cardiovascular_disease"
    })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" })
]).interpretation({ vocab: "ktx", code: "has_cardiovascular_disease_choice" });
const cardiovascularDiseaseType = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.PRIMARY_HYPERTENSION)
        .interpretation({ vocab: "ktx", code: "primary_hypertension" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.SECONDARY_HYPERTENSION)
        .interpretation({ vocab: "ktx", code: "secondary_hypertension" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.TIA_ISCHEMIC_STROKE)
        .interpretation({ vocab: "ktx", code: "TIA_ischemic_stroke" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.HAEMORRHAGIC_STROKE)
        .interpretation({ vocab: "ktx", code: "haemorrhagic_stroke" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.CORONARY_DISEASE),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.HYPERTHROPHIC_CARDIOMYOPATHY)
        .interpretation({ vocab: "ktx", code: "hyperthrophic_cardiomyopathy" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.DIALATATIVE_CARDIOMYOPATHY)
        .interpretation({ vocab: "ktx", code: "dialatative_cardiomyopathy" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.ATRIAL_FIBRILLATION_OR_OTHER_ARRYTHMIA)
        .interpretation({
        vocab: "ktx",
        code: "atrial_fibrillation_or_other_arrythmia"
    })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.AORTIC_STENOSIS_OR_INSUFFICIENCY)
        .interpretation({
        vocab: "ktx",
        code: "aortic_stenosis_or_insufficiency"
    })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.MITRAL_STENOSIS_OR_INSUFFICIENCY)
        .interpretation({
        vocab: "ktx",
        code: "mitral_stenosis_or_insufficiency"
    })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.AORTA_ANEURYSM)
        .interpretation({ vocab: "ktx", code: "aorta_aneurysm" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.ATHEROSCLEROSIS_ARTERIAE_CAROTIDEAE)
        .interpretation({
        vocab: "ktx",
        code: "atherosclerosis_arteriae_carotideae"
    })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.STENOSIS_ARTERIAE_CONORARIAE)
        .interpretation({ vocab: "ktx", code: "stenosis_arteriae_conorariae" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.STENOSIS_ARTERIAE_RENALIS)
        .interpretation({ vocab: "ktx", code: "stenosis_arteriae_renalis" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.PERIPHERAL_ARTERY_DIESEASE)
        .interpretation({ vocab: "ktx", code: "peripheral_artery_diesease" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.multiChoiceItem(CardiovascularDiseaseType.OTHER_CARDIOVASCULAR_DISEASE)
        .interpretation({ vocab: "ktx", code: "other_cardiovascular_disease" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" })
]);
const coronaryDiseaseType = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../cardiovascularDiseaseType}) && ({../cardiovascularDiseaseType}).includes("coronary_disease")`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITH_INTERVENTION)
        .interpretation({
        vocab: "ktx",
        code: "Coronary_artery_disease_obstructive_with_intervention"
    })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "coronary_disease" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.singleChoiceItem(CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_OBSTRUCTIVE_WITHOUT_INTERVENTION)
        .interpretation({
        vocab: "ktx",
        code: "Coronary_artery_disease_obstructive_without_intervention"
    })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "coronary_disease" })
        .tag({ vocab: "snomed", code: "49601007" }),
    schema_1.Schema.singleChoiceItem(CoronaryDiseaseType.CORONARY_ARTERY_DISEASE_NON_OBSTRUCTIVE)
        .interpretation({
        vocab: "ktx",
        code: "Coronary_artery_disease_non_obstructive"
    })
        .tag({ vocab: "ktx", code: "cardiovascular_disease_type" })
        .tag({ vocab: "snomed", code: "49601007" })
        .tag({ vocab: "ktx", code: "coronary_disease" })
        .tag({ vocab: "snomed", code: "49601007" })
]));
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_cardiovascular_disease"`), schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ cardiovascularDiseaseType, coronaryDiseaseType }));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases, comment })
    .interpretation({ vocab: "ktx", code: "cardiovascular_disease" });
